"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _set2 = _interopRequireDefault(require("lodash/set"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdFormik = require("cccisd-formik");
var _cccisdHiddenBlock = _interopRequireDefault(require("cccisd-hidden-block"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _MessageViewer = _interopRequireDefault(require("../../Messaging/MessageViewer"));
var _admin = require("../../../reducers/admin.js");
var _admin2 = require("../../../selectors/admin.js");
var _messageConditionTranslator = _interopRequireDefault(require("../../../helpers/messageConditionTranslator.js"));
var _style = _interopRequireDefault(require("./style.css"));
var _withMessageList = _interopRequireDefault(require("../../Messaging/withMessageList"));
var _LanguageToggle = _interopRequireDefault(require("../../Messaging/LanguageToggle.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Boilerplate = window.cccisd && window.cccisd.boilerplate;
var Fortress = window.cccisd && window.cccisd.fortress;
var SendMessageNow = /*#__PURE__*/function (_React$Component) {
  function SendMessageNow() {
    var _this;
    _classCallCheck(this, SendMessageNow);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, SendMessageNow, [].concat(args));
    _defineProperty(_this, "state", {
      loading: true,
      method: undefined,
      recipientCounts: {},
      templateId: -1
    });
    _defineProperty(_this, "loadCounts", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var response, recipientCounts;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return _cccisdAxios["default"].get(Boilerplate.route("api.assignmentDeploymentMessage.recipientCounts", {
              deploymentId: _this.props.deployment.deploymentId
            }));
          case 1:
            response = _context.v;
            recipientCounts = response.status === 200 ? response.data.data : {};
            _context.n = 2;
            return _this.setState({
              loading: false,
              recipientCounts: recipientCounts
            });
          case 2:
            return _context.a(2);
        }
      }, _callee);
    })));
    _defineProperty(_this, "getSelectedRows", function () {
      return _this.props.rtComponent.table.state.selectedRows;
    });
    _defineProperty(_this, "getSelectedRowData", function () {
      var rtState = _this.props.rtComponent.state;
      var tableState = _this.props.rtComponent.table.state;
      return tableState.data.filter(function (row) {
        return tableState.selectedRows.includes(row["".concat(rtState.pawnIdPath, "pawnId")]);
      });
    });
    _defineProperty(_this, "getEligibleRows", function (values) {
      var allRows = _this.getSelectedRowData();
      var method = values.method;
      if (_this.hasRecipientChain(values)) {
        return allRows;
      }
      return allRows.filter(function (row) {
        if (method === 'email') {
          return row["".concat(_this.props.rtComponent.state.userPath, "user.email")];
        }
        if (method === 'sms') {
          return row["".concat(_this.props.rtComponent.state.userPath, "user.phone")];
        }
        return false;
      });
    });
    _defineProperty(_this, "getPreviewMessageObject", function (values, isPreview) {
      var msg = _this.props.messageList.find(function (e) {
        return e.messageId === values.template;
      });
      var msgLabel = msg ? msg.settings.label : '';
      var condition = !_this.getSelectedRows().length && msg ? msg.condition : 'scheduled';
      var eligiblePawnIds = _this.getEligibleRows(values).map(function (e) {
        return e["".concat(_this.props.rtComponent.state.pawnIdPath, "pawnId")];
      });
      var recipients = eligiblePawnIds.length ? eligiblePawnIds : [];
      var msgObj = {
        condition: condition,
        messageMethod: values.method,
        category: 'preview',
        recipients: recipients,
        settings: {
          label: msgLabel,
          recipientsType: 'respondent'
        }
      };

      // Preview one language at a time but Submit info for all possible languages
      var messageInfo = {};
      if (isPreview) {
        var valuesBase = values.currLang && values.currLang !== 'en' ? values[values.currLang] : values;
        messageInfo = values.method === 'email' ? {
          subject: valuesBase.subject,
          body: valuesBase.body,
          outroLines: valuesBase.outroLines,
          actionText: valuesBase.actionText,
          actionUrl: valuesBase.actionUrl,
          pawnId: recipients.length ? recipients[0] : null // MessageViewer will use acting ID
        } : {
          body: valuesBase.body
        };
      } else {
        _this.getLanguages().forEach(function (lang) {
          var prefix = lang === 'en' ? '' : lang + '.';
          var expectedFields = values.method === 'email' ? ['subject', 'body', 'outroLines', 'actionText', 'actionUrl'] : ['body'];
          expectedFields.forEach(function (field) {
            (0, _set2["default"])(messageInfo, "".concat(prefix).concat(field), (0, _get2["default"])(values, "".concat(prefix).concat(field), ''));
          });
        });
      }
      msgObj.messageInfo = messageInfo;
      return msgObj;
    });
    _defineProperty(_this, "hasRecipientChain", function (values) {
      var settings = _this.props.deployment.settings;
      var chainPath = values.method === 'email' ? 'chainEmailFromPawn' : 'chainPhoneFromPawn';
      var recipientChain = settings && settings[chainPath];
      return !!recipientChain;
    });
    _defineProperty(_this, "renderSendInfo", function (values, selectedTemplate) {
      var recipientCounts = _this.state.recipientCounts;
      var selectedRows = _this.getSelectedRows();
      var eligibleSelected = _this.getSelectedRowData().filter(function (row) {
        if (values.method === 'email') {
          return row["".concat(_this.props.rtComponent.state.userPath, "user.email")];
        }
        if (values.method === 'sms') {
          return row["".concat(_this.props.rtComponent.state.userPath, "user.phone")];
        }
        return false;
      });
      var hasRecipientChain = _this.hasRecipientChain(values);
      var allIneligible = selectedRows.length && !hasRecipientChain ? eligibleSelected.length === 0 : false;
      var recipientCountData = recipientCounts[selectedTemplate.condition] || {};
      var recipientCount = recipientCountData[values.method];
      var recipientTotal = recipientCountData.total;
      var conditionName = (0, _messageConditionTranslator["default"])(selectedTemplate.condition);
      var sendInfo = selectedRows.length ? "Send to the ".concat(eligibleSelected.length, " ").concat(eligibleSelected.length !== selectedRows.length ? 'eligible' : '', " selected.").concat(selectedRows.length === eligibleSelected.length ? '' : " (".concat(selectedRows.length - eligibleSelected.length, " selected without ").concat(values.method === 'email' ? 'an email address' : 'a phone number', ".)")) : "Send to the ".concat(recipientCount, " ").concat(recipientTotal > recipientCount ? 'eligible' : '', " respondent").concat(recipientCount === 1 ? '' : 's', " ").concat(selectedTemplate.condition === 'all_respondents' ? '' : "meeting condition \"".concat(conditionName, "\"")).concat(recipientTotal === recipientCount ? '' : " (".concat(recipientTotal - recipientCount, " other").concat(recipientTotal - recipientCount > 1 ? 's' : '', " without ").concat(values.method === 'email' ? 'an email address' : 'a phone number', ")."));
      if (allIneligible) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "alert alert-danger ".concat(_style["default"].sendInfo),
          role: "alert"
        }, "All selected (", selectedRows.length, ") have an empty", ' ', values.method === 'email' ? 'email address' : 'phone number', ".");
      }
      if (!selectedRows.length && recipientCount === 0) {
        if (recipientTotal === 0) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: "alert alert-danger ".concat(_style["default"].sendInfo),
            role: "alert"
          }, "No respondents match the criteria \"".concat(conditionName, "\"."));
        }
        if (!hasRecipientChain) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: "alert alert-danger ".concat(_style["default"].sendInfo),
            role: "alert"
          }, "All respondents (".concat(recipientTotal, ") ").concat(selectedTemplate.condition === 'all_respondents' ? '' : "meeting condition \"".concat(conditionName, "\""), "\n                     have an empty ").concat(values.method === 'email' ? 'email address' : 'phone number', "."));
        }
      }
      if (hasRecipientChain) {
        sendInfo = selectedRows.length ? "Attempt to send to the ".concat(selectedRows.length, " selected respondents.") : "Attempt to send to all ".concat(recipientTotal, " respondents meeting condition \"").concat(conditionName, "\".");
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "alert alert-info ".concat(_style["default"].sendInfo),
        role: "alert"
      }, sendInfo);
    });
    _defineProperty(_this, "hasEligibleRecipients", function (values) {
      var messageList = _this.props.messageList;
      var recipientCounts = _this.state.recipientCounts;
      var method = values.method,
        template = values.template;
      var selectedRows = _this.getSelectedRows();
      var selectedTemplate = messageList.find(function (e) {
        return e.messageId === template;
      });
      var conditionCounts = recipientCounts[selectedTemplate.condition] || {};
      if (_this.hasRecipientChain(values)) {
        return selectedRows.length || conditionCounts.total;
      }
      if (selectedRows.length) {
        var eligibleSelected = _this.getSelectedRowData().filter(function (row) {
          if (method === 'email') {
            return row["".concat(_this.props.rtComponent.state.userPath, "user.email")];
          }
          if (method === 'sms') {
            return row["".concat(_this.props.rtComponent.state.userPath, "user.phone")];
          }
          return false;
        });
        return eligibleSelected.length > 0;
      }
      return conditionCounts[method] > 0;
    });
    /* /////////////////////////////////////////////////////////////////////////
    // FORMIK METHODS /////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////// */
    _defineProperty(_this, "onSubmit", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(values) {
        var formattedValues, response;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              formattedValues = _this.getPreviewMessageObject(values, false);
              delete formattedValues.category;
              formattedValues.scheduleTime = _momentTimezone["default"].utc().add(20, 'seconds').format();
              _context2.n = 1;
              return _cccisdAxios["default"].post(Boilerplate.route("api.assignmentDeploymentMessage.store", {
                deploymentId: _this.props.deployment.deploymentId
              }), formattedValues);
            case 1:
              response = _context2.v;
              if (!(response.data.status === 'success')) {
                _context2.n = 2;
                break;
              }
              _this.props.closeModal();
              _this.props.reloadCurrentProject();
              return _context2.a(2, (0, _cccisdNotification["default"])({
                type: 'success',
                message: "Successfully scheduled respondent message \"".concat(formattedValues.settings.label, "\"")
              }));
            case 2:
              (0, _cccisdNotification["default"])({
                type: 'danger',
                message: "Failed to schedule respondent message \"".concat(formattedValues.settings.label, "\""),
                duration: 5000
              });
            case 3:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "validate", function (values) {
      var errors = {};
      if (!_this.hasEligibleRecipients(values)) {
        errors._selected = 'All selected are invalid';
      }
      var languages = _this.getLanguages();
      languages.forEach(function (lang) {
        var prefix = lang === 'en' ? '' : "".concat(lang, ".");
        var subject = (0, _get2["default"])(values, "".concat(prefix, "subject"));
        var body = (0, _get2["default"])(values, "".concat(prefix, "body"));
        var outroLines = (0, _get2["default"])(values, "".concat(prefix, "outroLines"));
        var actionText = (0, _get2["default"])(values, "".concat(prefix, "actionText"));
        var actionUrl = (0, _get2["default"])(values, "".concat(prefix, "actionUrl"));
        if (values.method === 'email') {
          if (actionText && !actionUrl) {
            (0, _set2["default"])(errors, "".concat(prefix, "actionUrl"), 'You must supply a Button URL if Button Text is provided');
          }
          if (!actionText && actionUrl) {
            (0, _set2["default"])(errors, "".concat(prefix, "actionText"), 'You must supply Button Text if a Button URL is provided');
          }
          if (!subject) {
            (0, _set2["default"])(errors, "".concat(prefix, "subject"), 'You must supply a Subject');
          }
          if (!body && !outroLines) {
            (0, _set2["default"])(errors, "".concat(prefix, "body"), 'You must supply either Body (upper) or Body (lower)');
            (0, _set2["default"])(errors, "".concat(prefix, "outroLines"), 'You must supply either Body (upper) or Body (lower)');
          }
        } else if (!body) {
          (0, _set2["default"])(errors, "".concat(prefix, "body"), 'You must supply a Body');
        }
      });
      if (values.method === 'email') {
        if (values.actionText && !values.actionUrl) {
          errors.actionUrl = 'You must supply a Button URL if Button Text is provided';
        }
        if (!values.actionText && values.actionUrl) {
          errors.actionText = 'You must supply Button Text if a Button URL is provided';
        }
        if (!values.subject) {
          errors.subject = 'You must supply a Subject';
        }
        if (!values.body && !values.outroLines) {
          errors.body = 'You must supply either Body (upper) or Body (lower)';
          errors.outroLines = 'You must supply either Body (upper) or Body (lower)';
        }
      } else if (!values.body) {
        errors.body = 'You must supply a Body';
      }
      return errors;
    });
    _defineProperty(_this, "getLanguages", function () {
      var _this$props$assignmen, _this$props$assignmen2;
      var languages = ['en'];
      if (Array.isArray((_this$props$assignmen = _this.props.assignment) === null || _this$props$assignmen === void 0 ? void 0 : (_this$props$assignmen2 = _this$props$assignmen.settings) === null || _this$props$assignmen2 === void 0 ? void 0 : _this$props$assignmen2.languages)) {
        languages = _this.props.assignment.settings.languages;
      }
      if (languages.length === 0) {
        languages = ['en'];
      }
      return languages;
    });
    /* /////////////////////////////////////////////////////////////////////////
    // RENDER /////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////// */
    _defineProperty(_this, "renderMessageInfoOverrides", function (formikProps) {
      var _formikProps$values;
      var languages = _this.getLanguages();
      var prefix = '';
      if (formikProps !== null && formikProps !== void 0 && (_formikProps$values = formikProps.values) !== null && _formikProps$values !== void 0 && _formikProps$values.currLang && formikProps.values.currLang !== 'en') {
        prefix = formikProps.values.currLang + '.';
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "pt-3"
      }, /*#__PURE__*/_react["default"].createElement(_LanguageToggle["default"], {
        languages: languages,
        errors: formikProps.submitCount > 0 ? formikProps.errors : {},
        currLang: formikProps.values.currLang,
        setLang: function setLang(lang) {
          return formikProps.setFieldValue('currLang', lang);
        }
      }), formikProps.values.method === 'email' && /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "".concat(prefix, "subject"),
        component: _cccisdFormik.CccisdInput,
        label: "Subject: *"
      }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "".concat(prefix, "body"),
        component: _cccisdFormik.CccisdTextarea,
        label: "Body".concat(formikProps.values.method === 'email' ? ' (upper)' : '', ":").concat(formikProps.values.method === 'sms' ? ' *' : '')
      }), formikProps.values.method === 'email' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "".concat(prefix, "actionText"),
        component: _cccisdFormik.CccisdInput,
        label: "Button Text:"
      }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "".concat(prefix, "actionUrl"),
        component: _cccisdFormik.CccisdInput,
        label: "Button URL:"
      }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "".concat(prefix, "outroLines"),
        component: _cccisdFormik.CccisdTextarea,
        label: "Body (lower):"
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].subNote
      }, "Note: To place the Data Collection Wave link in the message, type", ' ', /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].bold
      }, "%URL%"), " and the link will automatically be filled in when the message is sent. You can also insert ", /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].bold
      }, "%firstName%"), ",", ' ', /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].bold
      }, "%lastName%"), ", or ", /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].bold
      }, "%fullName%"), "."), !!Fortress.user.acting.is_super_user && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].subNote,
        style: {
          marginTop: '1em'
        }
      }, "To specify the URL of a different deployment, you can use one of the following two forms:", ' ', /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].bold
      }, "%dcwURLByHandle:your_custom_handle_here%"), " or", ' ', /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].bold
      }, "%dcwURLByEndpoint:your_custom_endpoint_here%"), ". You can specify data starting at the recipient pawn by using a \":\" separated path (e.g.,", ' ', /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].bold
      }, "%pawn:data:customPawnField%"), ")."));
    });
    return _this;
  }
  _inherits(SendMessageNow, _React$Component);
  return _createClass(SendMessageNow, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.getSelectedRows().length) {
        this.loadCounts();
      } else {
        this.setState({
          loading: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var messageList = this.props.messageList;
      var _this$state = this.state,
        loading = _this$state.loading,
        templateId = _this$state.templateId;
      if (loading) {
        return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
          loading: true
        });
      }
      var respondentConditions = ['all_respondents', 'complete', 'incomplete', 'incomplete_or_not_started', 'not_started', 'on_respondent_complete'];
      var templates = messageList.filter(function (msg) {
        return msg.category === 'TEMPLATE' && respondentConditions.includes(msg.condition);
      });
      var templateOptions = templates.map(function (item) {
        return {
          label: item.settings.label,
          value: item.messageId
        };
      });
      var methodOptions = [{
        label: 'Email Message',
        value: 'email'
      }, {
        label: 'SMS/Text Message',
        value: 'sms'
      }];
      var selectedTemplate = templates.find(function (e) {
        return e.messageId === templateId;
      });
      if (!selectedTemplate && templates.length) {
        selectedTemplate = templates[0];
      }
      var languages = this.getLanguages();
      var initialValues = {
        method: 'email',
        currLang: languages[0]
      };
      if (selectedTemplate) {
        initialValues.template = selectedTemplate.messageId;
        initialValues.method = selectedTemplate.messageMethod;
        initialValues = _objectSpread(_objectSpread({}, initialValues), (0, _cloneDeep2["default"])(selectedTemplate.messageInfo));
      } else {
        var messageLink = "".concat(this.props.match.url, "/messaging/").concat(this.props.deployment.deploymentId);
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "alert alert-danger",
          role: "alert"
        }, "You must first create a template message in the", ' ', /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
          className: "alert-link",
          to: messageLink
        }, "Message Settings"), ' ', "area.");
      }
      var initialMethod = initialValues.method;
      if (this.state.method) {
        if (initialMethod !== this.state.method) {
          this.getLanguages().forEach(function (langKey) {
            if (langKey === 'en') {
              initialValues.body = '';
            } else {
              (0, _set2["default"])(initialValues, "".concat(langKey, ".body"), '');
            }
          });
        }
        initialValues.method = this.state.method;
      }
      var sendInfo = this.renderSendInfo(initialValues, selectedTemplate);
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
        initialValues: initialValues,
        enableReinitialize: true,
        onSubmit: this.onSubmit,
        validate: this.validate,
        render: function render(props) {
          return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "template",
            component: _cccisdFormik.CccisdSelect,
            label: "Template (by Label): *",
            options: templateOptions,
            onChange: function onChange(e) {
              props.handleChange(e);
              _this2.setState({
                templateId: Number.parseInt(e.target.value, 10)
              });
            }
          }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "method",
            component: _cccisdFormik.CccisdSelect,
            label: "Message Type:",
            options: methodOptions,
            onChange: function onChange(e) {
              props.handleChange(e);
              if (initialMethod !== e.target.value) {
                _this2.editMessageBlock.setShow(true);
              }
              _this2.setState({
                method: e.target.value
              });
            }
          }), /*#__PURE__*/_react["default"].createElement(_cccisdHiddenBlock["default"], {
            title: "Edit Message",
            ref: function ref(e) {
              _this2.editMessageBlock = e;
            }
          }, _this2.renderMessageInfoOverrides(props)), sendInfo, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
            trigger: /*#__PURE__*/_react["default"].createElement("button", {
              type: "button",
              className: "btn btn-secondary ".concat(_style["default"].button)
            }, "Preview"),
            title: "Previewing message",
            size: props.values.method && props.values.method.toUpperCase() === 'EMAIL' ? 'large' : 'small'
          }, /*#__PURE__*/_react["default"].createElement(_MessageViewer["default"], {
            messageObject: _this2.getPreviewMessageObject(props.values, true),
            language: props.values.currLang
          })), /*#__PURE__*/_react["default"].createElement("button", {
            className: "btn btn-primary ".concat(_style["default"].button),
            type: "submit",
            disabled: props.isSubmitting
          }, "Send Message (Right Now)"));
        }
      }));
    }
  }]);
}(_react["default"].Component);
_defineProperty(SendMessageNow, "propTypes", {
  rtComponent: _propTypes["default"].object,
  assignment: _propTypes["default"].object,
  deployment: _propTypes["default"].object,
  messageList: _propTypes["default"].array,
  // From Redux
  reloadCurrentProject: _propTypes["default"].func,
  // From Modal
  closeModal: _propTypes["default"].func,
  // Required for getDeploymentById to work!
  match: _propTypes["default"].object.isRequired
});
_defineProperty(SendMessageNow, "defaultProps", {
  closeModal: function closeModal() {}
});
var mapStateToProps = function mapStateToProps(state) {
  return {
    deployment: (0, _admin2.getDeploymentById)(state.assignment.admin),
    assignment: (0, _admin2.getCurrentAssignment)(state.assignment.admin)
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, {
  reloadCurrentProject: _admin.reloadCurrentProject
})((0, _withMessageList["default"])(SendMessageNow));